import React from "react";
import { Car, Bus, Building2, Map, Plane, Users } from "lucide-react";

const services = [
  {
    icon: Car,
    title: "Car Rental",
    description:
      "Explore our extensive range of luxury car rentals in Trichy, designed to make your journey comfortable and stylish. With well-maintained vehicles and 24/7 support, we offer the best car rental experience.",
  },
  {
    icon: Bus,
    title: "Tempo Traveller Rental",
    description:
      "Travel in comfort and style with our spacious 17-seater and 14-seater Tempo Traveller. Perfect for group tours and family trips, our well-maintained vehicles are perfect for group travel.",
  },
  {
    icon: Building2,
    title: "Temple Tourism in South India",
    description:
      "Embark on a spiritual and enriching pilgrimage to the most sacred temples in South India. Our expert guides and flexible tour travel services ensure a smooth and peaceful journey.",
  },
  {
    icon: Map,
    title: "Local Travel Packages",
    description:
      "Explore the best of Trichy with our exclusive local travel packages. From historical sites to modern entertainment and memorable journeys, let us craft a unique itinerary tailored to your interests.",
  },
  {
    icon: Plane,
    title: "Airport Pickup & Drop",
    description:
      "Experience hassle-free and punctual airport transfer services. With our professional drivers and well-maintained vehicles, we ensure you reach the airport or your destination safely.",
  },
  {
    icon: Users,
    title: "Travel Guides",
    description:
      "Let our expert travel guides help you plan the perfect itinerary. With extensive local recommendations and detailed insights, we ensure your journey is tailored to your preferences.",
  },
];

export default function Services() {
  return (
    <section id="services" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-4">
          Our Services
        </h2>
        <p className="text-xl text-center text-gray-700 mb-12">
          Tourism & Traveling Services
        </p>

        <div
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8"
          role="list"
        >
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white p-6 rounded-lg shadow-lg hover:shadow-xl hover:scale-105 transition transform flex flex-col items-center justify-center"
              role="listitem"
            >
              {service.icon && (
                <service.icon
                  className="w-12 h-12 text-teal-600 mb-4"
                  aria-hidden="false"
                  role="img"
                  aria-label={service.title}
                />
              )}
              <h3 className="text-xl font-semibold mb-3">{service.title}</h3>
              <p className="text-gray-700">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
